// src/pages/NotFoundPage.jsx

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    // Background: Light slate / Dark gray
    <div className="flex flex-col items-center justify-center min-h-screen bg-slate-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100 px-4 transition-colors duration-300">
      <div className="text-center">
        {/* 404 Text: Vibrant gradient visible on both light and dark */}
        <h1 className="text-9xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-pink-500">
          404
        </h1>
        
        {/* Title: Dark in light mode, White in dark mode */}
        <h2 className="text-3xl font-semibold text-gray-900 dark:text-white mt-4 mb-2">Oops! Page Not Found</h2>
        
        {/* Description */}
        <p className="text-gray-500 dark:text-gray-400 mb-8 max-w-md mx-auto">
          The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
        </p>
        
        <div className="flex gap-4 justify-center">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 px-6 py-3 bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 text-gray-900 dark:text-white rounded-lg transition-all"
          >
            <ArrowLeft size={20} /> Go Back
          </button>
       
          <button
            onClick={() => navigate('/dashboard')}
            className="flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white rounded-lg transition-all shadow-md"
          >
            <Home size={20} /> Dashboard
          </button>
        </div>
      </div>
    </div>
  );
}